export const clearJWTCookie = () => {
  try {
    // set cookie for jwt in new web app
    // @ts-expect-error - window is a global object
    const domain = new URL(window.location);
    const hostname = domain.hostname.replace(/^(.*\.)?www\./, '');
    document.cookie =
      'qm.jwt=; domain=' +
      hostname +
      '; path=/; secure;';
  } catch (e) {}

}

export const clearAppContextCookie = () => {
  try {
    // set cookie for jwt in new web app
    // @ts-expect-error - window is a global object
    const domain = new URL(window.location);
    const hostname = domain.hostname.replace(/^(.*\.)?www\./, '');
    document.cookie =
      'qm.appContext=; domain=' +
      hostname +
      '; path=/; secure;';
  } catch (e) {}
}